import React, { Fragment, useEffect, useRef, useState } from "react";
import { clientDepartmentInitialsForAdd, clientDepartmentInitialsForUpdate } from "./interfaces/ClientDepartmentClass";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { addAccountClientDepartmentAsync, updateAccountClientDepartmentAsync, resetSelectedRecordObjectInState } from "./ClientDepartmentSlice";
import { ShowToast } from '../../../common/Toastr';
import * as yup from 'yup';
import { Formik } from 'formik';
import { getValueFromResource } from "../../../common/timeLiveFunction";
export const ClientDepartmentForm = (props: any) => {
    const defaultFocusRef = useRef<HTMLInputElement>(null);
    const { AccountPartyId, t } = props;
    const [currentFieldsData, setCurrentFieldsData] = useState<any>(clientDepartmentInitialsForAdd)
    const { selectedRecord, isLoading } = useAppSelector((state) => state.clientDepartment);
    const dispatch = useAppDispatch();
    const closeButtonRef = useRef<HTMLButtonElement | null>(null);
    const formikRef = useRef<any>(null);
    useEffect(() => {
        let stateItem: any = {}
        if (Object.keys(selectedRecord).length > 0) {
            const tempObj: any = selectedRecord;
            Object.keys(clientDepartmentInitialsForUpdate).map((item) => {
                if (item === 'AccountPartyId') {
                    return stateItem[item] = AccountPartyId;
                }
                else {
                    return stateItem[item] = tempObj[item];
                }
            })
            setCurrentFieldsData(stateItem);
        }
        else {
            setCurrentFieldsData(clientDepartmentInitialsForAdd);
            setCurrentFieldsData({ ...clientDepartmentInitialsForAdd, "AccountPartyId": AccountPartyId });
        }
        if (defaultFocusRef.current) {
            defaultFocusRef.current.focus();
        }
        if (formikRef.current) {
            formikRef.current.resetForm();
        }
    }, [selectedRecord])

    const handleSubmit = (values: any) => {
        if (Object.keys(selectedRecord).length > 0) {
            dispatch(updateAccountClientDepartmentAsync(values))
                .unwrap()
                .then((originalPromiseResult) => {
                    originalPromiseResult.StatusCode === "200" ?
                        ShowToast("Client Department Update Successfully", 'Success', "success", "toast-top-right") :
                        ShowToast('error', originalPromiseResult.ResponseMessage, "error", "toast-top-right");
                })
                .catch((rejectedValueOrSerializedError) => {
                })
        }
        else {
            dispatch(addAccountClientDepartmentAsync(values))
                .unwrap()
                .then((originalPromiseResult) => {
                    originalPromiseResult.StatusCode === "201" ?
                        ShowToast("Client Department Added Successfully", 'Success', "success", "toast-top-right") :
                        ShowToast('error', originalPromiseResult.ResponseMessage, "error", "toast-top-right");
                })
                .catch((rejectedValueOrSerializedError) => {
                })

        }
        if (closeButtonRef.current) {
            closeButtonRef.current.click();
        }
    }
    const handleCloseOnClickEvent = () => {
        dispatch(resetSelectedRecordObjectInState());
    }
    return (
        <>
            <Formik
                innerRef={formikRef}
                initialValues={currentFieldsData}
                enableReinitialize={true}
                onSubmit={(values, action) => { handleSubmit(values); action.resetForm() }}
                validationSchema={yup.object().shape({
                    PartyDepartmentCode: yup
                        .string()
                        .label('PartyDepartmentCode')
                        .trim()
                        .required(getValueFromResource('Department Code is required', dispatch, t)),
                    PartyDepartmentName: yup
                        .string()
                        .label('PartyDepartmentName')
                        .trim()
                        .required(getValueFromResource('Department Name is required', dispatch, t))
                })}>
                {({ values, handleChange, errors, setFieldTouched, touched, isValid, handleSubmit }) => (
                    <Fragment>

                        <div className='card-body'>
                            {isLoading ?
                                <div className="col-md-12">
                                    <span className='indicator-progress' style={{ display: 'block' }}>
                                        <span className='spinner-border spinner-border-md ms-2'></span>
                                    </span>
                                </div>
                                : <>
                                    <div className='row '>
                                        <div className="col-md-6">
                                            <label className="fs-7 fw-normal mb-2">
                                                {/* {t('Department Code')} */}
                                                {getValueFromResource('Department Code',dispatch, t)}
                                                </label>
                                            <input type="text" className="form-control fs-7 fw-normal" name="PartyDepartmentCode" id='PartyDepartmentCode' value={values.PartyDepartmentCode}
                                                onChange={handleChange('PartyDepartmentCode')}
                                                ref={defaultFocusRef}
                                                // onBlur={() => setFieldTouched('PartyDepartmentCode')}
                                            />
                                            <div>
                                                {touched.PartyDepartmentCode && errors.PartyDepartmentCode &&
                                                    <p className='errorMsg'>{errors.PartyDepartmentCode as string}</p>
                                                }
                                            </div>
                                        </div>

                                        <div className="col-md-6">
                                            <label className="fs-7 fw-normal mb-2">
                                                {/* {t('Location')} */}
                                                {getValueFromResource('Location',dispatch, t)}
                                                </label>
                                            <input type="text" className="form-control fs-7 fw-normal" name="PartyDepartmentLocation" id='PartyDepartmentLocation' value={values.PartyDepartmentLocation}
                                                onChange={handleChange('PartyDepartmentLocation')}
                                                onBlur={() => setFieldTouched('PartyDepartmentLocation')}
                                            />
                                        </div>
                                        </div>
                                        <div className='row mt-4 '>
                                        <div className="col-md-6">
                                            <label className="fs-7 fw-normal mb-2">
                                                {/* {t('Department Name')} */}
                                                {getValueFromResource('Department Name',dispatch, t)}
                                                </label>
                                            <input type="text" className="form-control fs-7 fw-normal" name="PartyDepartmentName" id='PartyDepartmentName' value={values.PartyDepartmentName}
                                                onChange={handleChange('PartyDepartmentName')}
                                                onBlur={() => setFieldTouched('PartyDepartmentName')}
                                            />
                                            <div>
                                                {touched.PartyDepartmentName && errors.PartyDepartmentName &&
                                                    <p className='errorMsg'>{errors.PartyDepartmentName as string}</p>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </>
                            }
                        </div>
                        <div className='card-footer pt-4'>
                            <div className='d-flex flex-end'>
                                <button
                                    ref={closeButtonRef}
                                    type="button"
                                     className="btn btn-secondary btn-bs-btn-font-weight me-2 btn-sm fs-7"
                                    id="kt_OffCanvas"
                                    onClick={handleCloseOnClickEvent}
                                >
                                    {/* {t('Cancel')} */}
                                    {getValueFromResource('Cancel',dispatch, t)}
                                </button>

                                <button
                                    type="button"
                                     className="btn btn-sm btn-primary"
                                    onClick={() => handleSubmit()} disabled={!isValid}
                                    data-kt-element='send'
                                >
                                   {/* {t('Save')}  */}
                                   {getValueFromResource('Save',dispatch, t)}
                                </button>
                            </div>
                        </div>
                    </Fragment>
                )}
            </Formik>
        </>
    )
}

